import React from "react";
import { SportGroupCategoryProductMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";
import SportGroupCategoryProductModal from "@/Modals/WebDataManagement/Mapping/SportGroupCategoryProduct/Modal";

export default function SportGroupCategoryProductPage() {
  return (
    <MappingBaseTable
      label="Sport - Group - Category - Product"
      apiURL={SportGroupCategoryProductMappingsApi}
      columns={columns()}
      ModalComponent={SportGroupCategoryProductModal}
      importData={BASE_IMPORT_DATA.SPORT_GROUP_CATEGORY_PRODUCT}
      modalDataName={""}
      enableAdd={true}
      enableEdit={false}
      enableDelete={true}
    />
  );
}
